import styled from 'styled-components';
import PropTypes from 'prop-types';
import UnderlineLink from '@comp/UnderlineLink/UnderlineLink';
import H2 from '@base/H2/H2';
import H6 from '@base/H6/H6';
import P1 from '@base/P1/P1';
import TextField from '@base/TextField/TextField';
import Button from '@base/Button/Button';
import { Spacings, Fonts, TextColors } from '@styles/index';

const FlexDiv = styled.div`
  display: flex;
  margin-top: ${Spacings.SPACING_3B};
  margin-bottom: ${Spacings.SPACING_8B};
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      margin: 16px 0;
  };`}
`;

const InputField = styled(TextField)`
  &.MuiOutlinedInput-root {
    .MuiOutlinedInput-input {
      ${({ theme }) => `${theme.breakpoints.down('mobile')} {
        font-size: 12px;
      };`}
    }
  }
`;

const StyledP1 = styled(P1)`
  margin-right: ${Spacings.SPACING_1B};
`;

const StyledH6 = styled(H6)`
  font-weight: ${Fonts.BOLD};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${Spacings.SPACING_8B};
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      margin-top: 16px;
  };`}
`;

const LoginButton = styled(Button)`
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      width: 110px;
  };`}
`;

const Header = styled(H2)`
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      font-size: 16px;
  };`}
`;

const EnterEmailStep = ({
  changeAccountType,
  switchLoginType,
  email,
  setEmail,
  submitEmail,
  errorMsg
}) => {
  const onEmailChange = (e) => {
    setEmail(e.target.value.replace(/ /g, ''));
  };
  const toggleAccountType = (e) => {
    e.preventDefault();
    changeAccountType();
  };
  const switchToNumberLogin = (e) => {
    e.preventDefault();
    switchLoginType();
  };
  const onButtonClick = () => {
    submitEmail();
  };

  return (
    <>
      <Header>Login</Header>
      <FlexDiv>
        <StyledP1>or</StyledP1>
        <UnderlineLink
          color={TextColors.GREEN}
          onClick={toggleAccountType}
          href="#"
        >
          <StyledH6 color={TextColors.GREEN}>create your account</StyledH6>
        </UnderlineLink>
      </FlexDiv>

      <InputField
        fullWidth
        placeholder="Email address"
        onChange={onEmailChange}
        value={email}
        inputProps={{
          required: true
        }}
        type="email"
        autoFocus
        error={errorMsg !== ''}
        helperText={errorMsg}
        enterCallback={onButtonClick}
      />

      <ButtonWrapper>
        <LoginButton
          variant={email ? 'filled' : 'disabled'}
          label="Login"
          onClick={onButtonClick}
          grid={3}
        />
        <UnderlineLink onClick={switchToNumberLogin} href="#">
          <StyledH6>Continue with mobile number</StyledH6>
        </UnderlineLink>
      </ButtonWrapper>
    </>
  );
};

export default EnterEmailStep;

EnterEmailStep.propTypes = {
  email: PropTypes.string.isRequired,
  changeAccountType: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
  submitEmail: PropTypes.func.isRequired,
  switchLoginType: PropTypes.func.isRequired,
  errorMsg: PropTypes.string.isRequired
};
